import { render, staticRenderFns } from "./SetStartFeeArgsForm.vue?vue&type=template&id=32566a16&scoped=true&"
import script from "./SetStartFeeArgsForm.vue?vue&type=script&lang=ts&"
export * from "./SetStartFeeArgsForm.vue?vue&type=script&lang=ts&"
import style0 from "./SetStartFeeArgsForm.vue?vue&type=style&index=0&id=32566a16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32566a16",
  null
  
)

export default component.exports